import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";
import AttachmentTypes_popup_AddAttachmentType from './Popups/AttachmentTypes_popup_AddAttachmentType';

const AttachmentTypes: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const [showAddPopup, setShowAddPopup] = useState(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/attachmenttypes')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/attachmenttypes/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Abbr.', dataProp: 'abbreviation', filterInfo: { filterType: 'Textbox' } },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Datasource', dataProp: 'dataSourceType.name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Generatable', dataProp: 'isGeneratable', dataType: 'bool', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Can delete', dataProp: 'canDelete', dataType: 'bool', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Startdate', dataProp: 'beginDate', dataType: 'date' },
        { title: 'Enddate', dataProp: 'endDate', dataType:'date' },
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditBrand)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowAddPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Attachment types'
                                content={
                                    <DataTable
                                        name='dtAttachmentTypes'
                                        tableData={data}
                                        colInfos={colInfos}
                                        navigateTitle='Attachment type'
                                        navigateUrl='/plm/Communication/AttachmentType/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
                {showAddPopup && <AttachmentTypes_popup_AddAttachmentType show={showAddPopup} onHide={() => { setShowAddPopup(false); getTableData(); }} />}
            </div>
        </>
    );
}
export default AttachmentTypes;